import { Button, Flex, Heading, Image, Text } from '@chakra-ui/react';

interface Props {
  onClickCreateGiftCard?: () => void;
}

const GiftCardIntroCard = ({ onClickCreateGiftCard }: Props) => {
  return (
    <Flex flexDir="column" gap={4}>
      <Image h="2xs" fit="contain" src="/images/gifts-min.png" alt="Gift cards" />
      <Flex flexDir="column" gap={4} alignItems="center">
        <Heading>Add value to your business with rental gift cards</Heading>
        <Text maxW="xl">
          Gift cards are a great way to reward your customers or offer them perks for their
          patronage or loyalty.
        </Text>
        <Button onClick={onClickCreateGiftCard} size="xs">
          Create gift card
        </Button>
      </Flex>
    </Flex>
  );
};

export default GiftCardIntroCard;
